import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateActivityTemplateMutation as UpdateActivityTemplateMutationType,
  UpdateActivityTemplateMutationVariables,
} from "./__generated__/UpdateActivityTemplateMutation";

const UpdateActivityTemplateMutation = loader("./UpdateActivityTemplateMutation.gql");

type UpdateActivityTemplateMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateActivityTemplateMutationType) => void;
}) => ReactElement;

export const UpdateActivityTemplateMutationProvider: UpdateActivityTemplateMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<
    UpdateActivityTemplateMutationType,
    UpdateActivityTemplateMutationVariables
  >(UpdateActivityTemplateMutation, {
    errorPolicy: "none",
    onError,
    onCompleted,
  });

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
